
'use strict'

import { PURCHASERECORD } from "../constants/ActionTypes"

const initState = {
    purchaseRecord: null
}

export default function ( state = initState, action = {} ){
    switch( action.type ){

        case PURCHASERECORD.PURCHASERECORD :
            return Object.assign({},state,{
                purchaseRecord: action.data
            });
        break;
        default:
            return state;break;
    }
}





// WEBPACK FOOTER //
// ./common/reducers/purchaseRecord.js